var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"version-list",on:{"scroll":_setup.debouncedOnScroll}},[_c('ul',_vm._l((_vm.versions),function(version){return _c(_setup.VersionListItem,{key:version.id,attrs:{"version":version}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }